const axios = require('axios').default;

const headersFor = (jwtToken) => ({ headers: { Authorization: jwtToken } });
const usersUrl = (base, companyId) => `${base}/companies/${companyId}/users`;

export const listUsers = (base, jwtToken, companyId) =>
  axios.get(usersUrl(base, companyId), headersFor(jwtToken)).then((r) => r.data.users);

export const updateUserRole = (base, jwtToken, companyId, userId, role) =>
  axios.put(`${usersUrl(base, companyId)}/${userId}`, { role }, headersFor(jwtToken)).then((r) => r.data);

export const removeUser = (base, jwtToken, companyId, userId) =>
  axios.delete(`${usersUrl(base, companyId)}/${userId}`, headersFor(jwtToken)).then(() => undefined);

export const addUser = (base, jwtToken, companyId, email, role) =>
  axios.post(usersUrl(base, companyId), { email, role }, headersFor(jwtToken)).then((r) => r.data);

export const errorMessage = (error, fallback) =>
  (error && error.response && error.response.data && error.response.data.message) || fallback;

export async function applyRoleChange(users, userId, role, update) {
  try {
    const updated = await update(userId, role);
    return { users: users.map((u) => (u.user_id === userId ? updated : u)) };
  } catch (error) {
    return { users, error: errorMessage(error, 'Could not change role.') };
  }
}
